var map = {
	"./notificacion_categoria_acciones.png": 486,
	"./notificacion_categoria_cumpleanios.png": 487,
	"./notificacion_categoria_eventos.png": 488,
	"./notificacion_categoria_importaciones.png": 489,
	"./notificacion_categoria_nominas.png": 490,
	"./notificacion_categoria_recordatorios.png": 491,
	"./notificacion_categoria_solicitudes_vacaciones.png": 492,
	"./notificacion_default.png": 493
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 485;